import tools from '@/utils/tools'

function cache (key, url) {
  // key  存入缓存的名称
  // url  请求的路径
  if (sessionStorage.getItem(key)) {
    return JSON.parse(sessionStorage.getItem(key))
  }
  // 第一步： 获得XMLHttpRequest对象
  const xhr = new XMLHttpRequest()
  // 第三步： open一个链接
  xhr.open('get', url, false)
  const authorization = tools.authorization()
  if (authorization) {
    xhr.setRequestHeader('Authorization', authorization)
  }
  // 第二步： 设置状态监听函数
  xhr.onreadystatechange = function () {
    // 第五步：在监听函数中，判断readyState=4 && status=200表示请求成功
    if (xhr.readyState === 4 && xhr.status === 200) {
      // 第六步： 使用responseText、responseXML接受响应数据，并使用原生JS操作DOM进行显示
      const reqData = JSON.parse(xhr.responseText)
      sessionStorage.setItem(key, JSON.stringify(reqData.data))
    }
  }
  // 第四步： send一个请求。 可以发送对象和字符串，不需要传递数据发送null
  xhr.send(null)
  const result = JSON.parse(sessionStorage.getItem(key))
  return result
}

function getByKey (listFun, cacheKey, keyName, valueName, key) {
  const str = sessionStorage.getItem(cacheKey)
  if (str) {
    const findObj = JSON.parse(str)[key]
    if (findObj) {
      return findObj[valueName]
    }
    return undefined
  }
  const list = listFun()
  const obj = {}
  list.forEach(function (item) {
    obj[item[keyName]] = item
  })
  sessionStorage.setItem(cacheKey, JSON.stringify(obj))
  return getByKey(listFun, cacheKey, keyName, valueName, key)
}

export const userInfo = {
  userDeptDist () {
    const result = cache('dict.user.deptDist', `${process.env.VUE_APP_SERVER_URL}/ucenter/user/getUserDeptDist`)
    return result
  },
  districtId () {
    const userDeptDist = userInfo.userDeptDist()
    return userDeptDist.districtId
  }
}

// 部门
export const department = {
  // params 支持name、districtId、parentId
  list () {
    const result = cache('dict.department.list', `${process.env.VUE_APP_SERVER_URL}/dist/department/front/list`)
    return result
  },
  // key支持name、parentId
  value (id, key) {
    const cacheKey = 'dict.department.obj'
    return getByKey(department.list, cacheKey, 'id', key, id)
  }
}

// 地区
export const district = {
  list () {
    const result = cache('dict.district.list', `${process.env.VUE_APP_SERVER_URL}/dict/district/front/list`)
    return result
  },
  // key支持name、parentId
  name (id) {
    const cacheKey = 'dict.district.obj'
    return getByKey(district.list, cacheKey, 'id', 'name', id)
  }
}
